import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setBookedSlotsList, setSlotsList, setSlotsPageReadonly } from "@/app_redux/reducers/slices/auth/slots_slice";
import { useEffect } from "react";
import { Outlet } from "react-router";
import SlotsHeaderContainer from "../../SlotsScreen/SlotsHeaderContainer";

const CheckSlotsComponent = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setSlotsPageReadonly(true));
    dispatch(
      setSlotsList({
        data: [],
      }),
    );
    dispatch(setBookedSlotsList({ data: [] }));
  }, []);
  return (
    <>
      <SlotsHeaderContainer />
      <Outlet />
    </>
  );
};

export default CheckSlotsComponent;
